import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';

@Injectable()
export class LandlineMissionService {

  constructor(private apiService: ApiService) {}

  /**
   * Update mission
   */
  update(object: any, procedureCode: string): Observable<any> {
    return this.apiService.put('landline/mission/' + procedureCode, object);
  }

  /**
   * Save mission
   */
  save(object: any, procedureCode: string): Observable<any> {
    return this.apiService.post('landline/mission/' + procedureCode, object);
  }
}
